<template lang="html">
    <div class="analytics-date-filter">
        <ds-input-field
            v-if="showNumDays"
            v-model="filter.value"
            type="number"
            placeholder="Days"
            :step="1"
            :min="1"
        />

        <ds-date-picker
            v-else
            v-model="filter.value"
            :range="isRange"
        />
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        value: Object,
    },

    data() {
        return {
            filter: this.value,
        };
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },

        filter: {
            handler() {
                this.updateQuery();
            },
            deep: true,
        },

        'filter.modifier': function() {
            this.filter.value = '';
        },
    },

    computed: {
        showNumDays() {
            return this.filter.modifier === 'within';
        },

        isRange() {
            return this.filter.modifier === 'between';
        },
    },

    methods: {
        updateQuery() {
            let query = '';

            const FORMAT = 'YYYY/MM/DD';

            switch (this.filter.modifier) {
            case 'within':
                if (typeof this.filter.value === 'number' && this.filter.value > 0) {
                    query = `last ${this.filter.value} days`;
                }

                break;
            case 'between':
                if (Array.isArray(this.filter.value) && this.filter.value.length === 2) {
                    query = `${moment(this.filter.value[0]).format(FORMAT)} to ${moment(this.filter.value[1]).format(FORMAT)}`;
                }

                break;
            case 'before':
                if (typeof this.filter.value === 'object') {
                    query = `before ${moment(this.filter.value).format(FORMAT)}`;
                }

                break;
            case 'after':
                if (typeof this.filter.value === 'object') {
                    query = `after ${moment(this.filter.value).format(FORMAT)}`;
                }

                break;
            default:
                break;
            }

            this.filter.query = query;
        },
    },
};
</script>
